import { reactive } from 'vue'
import type { Petition, PetitionStatus, PetitionCategory, Priority } from '@/types'

export interface PetitionFilters {
  search: string
  status: PetitionStatus | ''
  category: PetitionCategory | ''
  priority: Priority | ''
  projectId: string
  organizationId: string
}

export interface PetitionState {
  petitions: Petition[]
  isLoading: boolean
  error: string | null
  filters: PetitionFilters
}

export const getInitialState = (): PetitionState => ({
  petitions: [],
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    category: '',
    priority: '',
    projectId: '',
    organizationId: '',
  },
})

export const createState = (): PetitionState => {
  return reactive(getInitialState())
}

export const resetState = (state: PetitionState): void => {
  const initial = getInitialState()
  state.petitions = initial.petitions
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
